// extracted by mini-css-extract-plugin
export default {"close-btn":"close-btn--QkBwu","closeBtn":"close-btn--QkBwu"};